import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom'; // Assuming you're using react-router-dom for navigation
import { getAdminUsers, deleteAdminUser, suspendAdminUser } from '../../services/adminApi';
import ReusableAdminTable from './ReusableAdminTable'; // Adjust path as needed
import { fetchUserJogetProfileApi } from '../../services/api';

// UI & Icons
import { Button, Badge } from 'react-bootstrap';
import { FiEdit,FiEye, FiTrash2, FiPauseCircle } from 'react-icons/fi';
import Swal from 'sweetalert2';

const AdminUsersList = ({ roleCode, title }) => {
    // Component-specific state
    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate(); // Initialize navigate hook

    // Component-specific data fetching logic
    const fetchUsers = async () => {
        setIsLoading(true);
        try {
            const res = await getAdminUsers(roleCode);
            setUsers(res.data);
        } catch (error) {
            console.error(`Error fetching ${title}`, error);
            setUsers([]); // Set to empty array on error
        } finally {
            setIsLoading(false);
        }
    };

    // Re-fetch data when the roleCode prop changes
    useEffect(() => {
        fetchUsers();
    }, [roleCode]);

    
    // const handleSuspend = async (id) => {
    // const userToSuspend = users.find(user => user.id === id);
    //     if (!userToSuspend) return;

    //     const confirmMessage = userToSuspend.is_suspended
    //         ? "Are you sure you want to unsuspend this user?"
    //         : "Are you sure you want to suspend this user?";

    //     if (window.confirm(confirmMessage)) {
    //         try {
    //             // await suspendAdminUser(id);
    //             // fetchUsers(); 
    //             await suspendAdminUser(id);

    //     setUsers(prev =>
    //     prev.map(user =>
    //         user.id === id
    //         ? { ...user, is_suspended: !user.is_suspended }
    //         : user
    //     )
    //     );
    //         } catch (error) {
    //             console.error("Failed to suspend/unsuspend user:", error);
    //             alert("Could not update user suspension status.");
    //         }
    //     }
    // };
    const handleSuspend = async (id) => {

    const userToSuspend = users.find(user => user.id === id);

    if (!userToSuspend) return;

    const isSuspended = userToSuspend.is_suspended;

    const result = await Swal.fire({
        title: isSuspended ? 'Unsuspend User?' : 'Suspend User?',
        text: isSuspended
            ? 'User account will be activated again.'
            : 'User account will be suspended.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: isSuspended ? '#f59e0b' : '#d33',
        cancelButtonColor: '#6c757d',
        confirmButtonText: isSuspended ? 'Yes, Unsuspend' : 'Yes, Suspend',
        cancelButtonText: 'Cancel',
        background: '#071427',
        color: '#fff'
    });

    if (result.isConfirmed) {

        try {

            await suspendAdminUser(id);

            setUsers(prev =>
                prev.map(user =>
                    user.id === id
                        ? { ...user, is_suspended: !user.is_suspended }
                        : user
                )
            );

            Swal.fire({
                title: 'Success!',
                text: isSuspended
                    ? 'User unsuspended successfully.'
                    : 'User suspended successfully.',
                icon: 'success',
                timer: 1800,
                showConfirmButton: false,
                background: '#071427',
                color: '#fff'
            });

        } catch (error) {

            console.error("Failed to suspend/unsuspend user:", error);

            Swal.fire({
                title: 'Error!',
                text: 'Could not update user status.',
                icon: 'error',
                background: '#071427',
                color: '#fff'
            });
        }
    }
};



    // Component-specific business logic (delete, edit navigation, etc.)
    // const handleDelete = async (id) => {
    //     if (window.confirm("Are you sure you want to delete this user?")) {
    //         try {
    //             await deleteAdminUser(id);
    //             fetchUsers(); // Refresh the list after deletion
    //         } catch (error) {
    //             console.error("Failed to delete user:", error);
    //             alert("Could not delete the user.");
    //         }
    //     }
    // };
    const handleDelete = async (id) => {

    const result = await Swal.fire({
        title: 'Delete User?',
        text: "Are you sure you want to delete this user?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Yes, Delete',
        cancelButtonText: 'Cancel',
        background: '#071427',
        color: '#fff'
    });

    if (result.isConfirmed) {
        try {

            await deleteAdminUser(id);

            await Swal.fire({
                title: 'Deleted!',
                text: 'User deleted successfully.',
                icon: 'success',
                timer: 1800,
                showConfirmButton: false,
                background: '#071427',
                color: '#fff'
            });

            fetchUsers();

        } catch (error) {

            console.error("Failed to delete user:", error);

            Swal.fire({
                title: 'Error!',
                text: 'Could not delete the user.',
                icon: 'error',
                background: '#071427',
                color: '#fff'
            });
        }
    }
};

   

    // const handleEdit = (id) => {
    const handleView = (id) => {


    // Candidate
    if (String(roleCode) === "300") {
        // navigate(`/admin/candidate-profile/${id}`);
        console.log("REDIRECTING TO:", `/admin/candidate-profile/${id}`);

navigate(`/admin/candidate-profile/${id}?mode=view`);
        return;
    }

    // Director
    if (String(roleCode) === "200") {
        navigate(`/admin/director-profile/${id}?mode=view`);
        return;
    }

    // Casting Director
    if (String(roleCode) === "400") {
        navigate(`/admin/casting-profile/${id}?mode=view`);
        return;
    }
};

    // const handleAddNew = () => {
    //     console.log(`Navigating to add new user for role: ${roleCode}`);
    // };
    const handleAddNew = () => {

    // Candidate
    if (String(roleCode) === "300") {
        navigate('/admin/candidate-profile/add');
        return;
    }

    // Director
    if (String(roleCode) === "200") {
        navigate('/admin/director-profile/add');
        return;
    }

    // Casting Director
    if (String(roleCode) === "400") {
        navigate('/admin/casting-profile/add');
        return;
    }
};

    // Component-specific column definitions, memoized for performance
    const columns = useMemo(() => [
        { accessorKey: 'id', header: 'ID' },
        { accessorKey: 'full_name', header: 'Name' },
        { accessorKey: 'email', header: 'Email' },
        { accessorKey: 'mobile_no', header: 'Phone' },
        {
            accessorKey: 'is_verified',
            header: 'Verification Status', // More descriptive header
            cell: info => (
                <Badge pill bg={info.getValue() ? 'success' : 'warning'}>
                    {info.getValue() ? 'Verified' : 'Pending Verification'}
                </Badge>
            )
        },
        {
            accessorKey: 'is_suspended',
            header: 'Account Status', // More descriptive header
            cell: info => (
                <Badge pill bg={info.getValue() ? 'danger' : 'success'}>
                    {info.getValue() ? 'Suspended' : 'Active'}
                </Badge>
            )
        },
                {
            id: 'actions',
            header: () => <div style={{ textAlign: 'center', width: '100%' }}>ACTIONS</div>,
            cell: ({ row }) => {
                const user = row.original;
                return (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', width: '100%', margin: '0 auto' }}>
                        {/* ✅ VIEW BUTTON: ROYAL BLUE */}
                        <button
                            type="button"
                            style={{
                                background: '#2563eb',
                                backgroundColor: '#2563eb',
                                color: '#ffffff',
                                border: 'none',
                                borderRadius: '6px',
                                width: '32px',
                                height: '32px',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                padding: 0,
                                flexShrink: 0
                            }}
                            onClick={() => handleView(user.id)}
                            title="View User"
                        >
                            <FiEye size={15} color="#ffffff" />
                        </button>

                        {/* ✅ DELETE BUTTON: CRIMSON RED */}
                        <button
                            type="button"
                            style={{
                                background: '#dc2626',
                                backgroundColor: '#dc2626',
                                color: '#ffffff',
                                border: 'none',
                                borderRadius: '6px',
                                width: '32px',
                                height: '32px',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                padding: 0,
                                flexShrink: 0
                            }}
                            onClick={() => handleDelete(user.id)}
                            title="Delete User"
                        >
                            <FiTrash2 size={15} color="#ffffff" />
                        </button>

                        {/* ✅ SUSPEND/UNSUSPEND BUTTON: AMBER / SLATE */}
                        <button
                            type="button"
                            style={{
                                background: user.is_suspended ? '#d97706' : '#4b5563',
                                backgroundColor: user.is_suspended ? '#d97706' : '#4b5563',
                                color: '#ffffff',
                                border: 'none',
                                borderRadius: '6px',
                                width: '32px',
                                height: '32px',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                padding: 0,
                                flexShrink: 0
                            }}
                            onClick={() => handleSuspend(user.id)}
                            title={user.is_suspended ? "Unsuspend User" : "Suspend User"}
                        >
                            <FiPauseCircle size={15} color="#ffffff" />
                        </button>
                    </div>
                );
            }
        }
    ], [users,handleView, handleDelete, handleSuspend]); // Added dependencies for functions

    // The entire UI is now delegated to the reusable component
    return (
        <ReusableAdminTable
            data={users}
            columns={columns}
            isLoading={isLoading}
            title={title}
            onAddNew={handleAddNew}
            addNewButtonText={`Add New ${title.replace(/s$/, '')}`} // More robust way to remove trailing 's'
            searchPlaceholder={`Search in ${title}...`}
            exportCsvFilename={`${title.toLowerCase().replace(/ /g, '_')}.csv`}
        />
    );
};

export default AdminUsersList;